import { lazy, Suspense } from 'react';
import { Outlet, Navigate, useRoutes } from 'react-router-dom';

import MainLayout from 'src/layouts/main';
import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('src/pages/home'));
const UCSNQ = lazy(() => import('src/pages/uc-snq'));
const Catalog = lazy(() => import('src/pages/catalog'));
const Contact = lazy(() => import('src/pages/contact'));
const Document = lazy(() => import('src/pages/document'));
const Equivalency = lazy(() => import('src/pages/equivalency'));
const News = lazy(() => import('src/pages/news'));
const RVCC = lazy(() => import('src/pages/rvcc'));
const SNQ = lazy(() => import('src/pages/snq'));
const Square = lazy(() => import('src/pages/square'));
const CatalogDetails = lazy(() => import('src/pages/catalog-details'));
const NewsDetails = lazy(() => import('src/pages/news_details'));
import { errorRoutes } from './error';

import { paths } from '../paths';

export default function Router() {
  return useRoutes([
    {
      element: (
        <MainLayout>
          <Suspense fallback={<SplashScreen />}>
            <Outlet />
          </Suspense>
        </MainLayout>
      ),

      children: [
        { element: <IndexPage />, index: true },
        { path: paths.ucsnq, element: <UCSNQ /> },
        { path: paths.catalog, element: <Catalog /> },
        { path: paths.contact, element: <Contact /> },
        { path: paths.document, element: <Document /> },
        { path: paths.equivalency, element: <Equivalency /> },
        { path: paths.news, element: <News /> },
        { path: paths.snq, element: <SNQ /> },
        { path: paths.square, element: <Square /> },
        { path: paths.rvcc, element: <RVCC /> },
        {
          path: paths.catalog_details,
          element: <CatalogDetails />,
        },
        { path: paths.news_details, element: <NewsDetails /> },
      ],
    },
    ...errorRoutes,

    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}
